import store from '@/app/store';
import Vue from 'vue';
import Router from 'vue-router';
import { isAuthDataReceived } from '@/app/store/auth-status';
import Home from '../components/Home';
import WrhDashboard from '../../modules/wrh-dashboard/app';
import WreDashboard from '../../modules/wre-dashboard/app';
import WrDashboard from '../../modules/wr-dashboard/app';
import WrNotaryCertificate from '../../modules/wr-notary-certificate/app';
import SharedLink from '../../modules/shared-link/app';
import Login from '../components/Login';
import RoAdminLoginError from '../components/RoAdminLoginError';
import AccessDeniedError from '../components/AccessDeniedError';
import MfaRequiredError from '../components/MfaRequiredError';
import ServerError from '../components/ServerError';
import ServerBusyError from '../components/ServerBusyError';
import IconsViewPage from '../components/IconsViewPage';

const isMspWr = process.env.VUE_APP_MSP_MODE === 'true';

Vue.use(Router);

const routes =
  isMspWr ?
    [
      {
        path: '/',
        name: 'wrHome',
        component: Home
      },
      {
        path: '/enterprise/login',
        name: 'wrLogin',
        component: Login
      },
      {
        path: '/error/ro-admin',
        name: 'ro-admin-login-error',
        component: RoAdminLoginError
      },
      {
        path: '/error/access-denied',
        name: 'access-denied-error',
        component: AccessDeniedError
      },
      {
        path: '/error/mfa-required',
        name: 'mfa-required-error',
        component: MfaRequiredError
      },
      {
        path: '/error/server-error',
        name: 'server-error',
        component: ServerError
      },
      {
        path: '/error/server-busy',
        name: 'server-busy-error',
        component: ServerBusyError
      },
      {
        path: '/enterprise/dashboard',
        component: WrDashboard.component,
        children: [...WrDashboard.routes]
      },
      {
        path: '/links/:cipher',
        component: SharedLink.component,
        children: [...SharedLink.routes]
      },
      {
        path: '/enterprise/certificate/:id',
        component: WrNotaryCertificate.component,
        children: [...WrNotaryCertificate.routes]
      },
      {
        path: '/error/icons',
        name: 'icons-view-page',
        component: IconsViewPage
      }
    ] : [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      {
        path: '/login',
        name: 'wrhLogin',
        component: Login
      },
      {
        path: '/enterprise/login',
        name: 'wreLogin',
        component: Login
      },
      {
        path: '/dashboard',
        component: WrhDashboard.component,
        children: [...WrhDashboard.routes]
      },
      {
        path: '/enterprise/dashboard',
        component: WreDashboard.component,
        children: [...WreDashboard.routes]
      },
      {
        path: '/links/:cipher',
        component: SharedLink.component,
        children: [...SharedLink.routes]
      },
      {
        path: '/error/access-denied',
        name: 'access-denied-error',
        component: AccessDeniedError
      },
      {
        path: '/error/mfa-required',
        name: 'mfa-required-error',
        component: MfaRequiredError
      },
      {
        path: '/error/server-error',
        name: 'server-error',
        component: ServerError
      },
      {
        path: '/error/server-busy',
        name: 'server-busy-error',
        component: ServerBusyError
      },
      {
        path: '/error/icons',
        name: 'icons-view-page',
        component: IconsViewPage
      }
    ];

const router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
});


/* eslint-disable consistent-return */
/** @type {import('vue-router').NavigationGuard} */
const checkAuthentication = isMspWr
  ? function checkAuthentication(to, from, next) {
    if (to.path.startsWith('/enterprise/certificate/')) {
      return next();
    }

    if (store.getters.isAuthenticated) {
      if (store.getters.subscription === 'WRE') {
        if (to.path !== '/enterprise/dashboard') {
          return next('/enterprise/dashboard');
        }
      }
    } else if (to.path !== '/enterprise/login') {
      return next('/enterprise/login');
    }

    return next();
  }
  : function checkAuthentication(to, from, next) {
    if (store.getters.isAuthenticated) {
      const dashboardPage = store.getters.subscription === 'WRE'
        ? '/enterprise/dashboard'
        : '/dashboard';

      return to.path !== dashboardPage
        ? next(dashboardPage)
        : next();
    }

    if (store.getters.isLoginPageEnabled) {
      const loginPage = store.getters.subscription === 'WRE'
        ? '/enterprise/login'
        : '/login';

      return to.path !== loginPage
        ? next(loginPage)
        : next();
    }

    // redirect to the global router
    window.location.assign(store.getters.loginApp);
  };

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/error/')) {
    return next();
  }
  if (to.path.startsWith('/links/')) {
    return next();
  }

  // no need store watcher if data is received
  if (isAuthDataReceived(store.state.authDataStatus)) {
    return checkAuthentication(to, from, next);
  }

  // watch store for the server data update and trigger navigation
  const unwatch = store.watch(
    () => isAuthDataReceived(store.state.authDataStatus),
    function (isReceived) {
      if (isReceived) {
        unwatch();
        checkAuthentication(to, from, next);
      }
    },
    { immediate: true }
  );
});

export default router;
